import { WidgetActions } from './actions';
import {STORAGE_KEY,VersionedState,STORAGE_VERSION } from './state';
import {ACCEPT_ODDS_CHANGES,
        ADD_BETS,REMOVE_EVENT,
        CHANGE_CULTURE,
        CLEAR_ALL,DISABLE,
        REMOVE_ON_ERROR,SHOW_ON_SUCCESS,
        ODDS_CHANGED,RECALCULATE,REMOVE_BETS,
        REMOVE_EVENT_BETS,RESTORE_STATE,
        SET_TOTAL_ODDS, UPDATE_CONFIG} from '../utils/consts';

import {removeBets, addBets, recalculate, setTotalOdds, removeEvent} from './stateUtils';

  
export const betReducer = (state: VersionedState, action: WidgetActions): VersionedState => {
  let newState: VersionedState;
  const config = state.config;
  switch (action.type) {
    case ADD_BETS: {
      newState = addBets(state,action.payload)
      break;
    }
    
    case REMOVE_BETS:
      newState = removeBets(state,action.payload)
      break;
    case SHOW_ON_SUCCESS:
      const sourceMap = new Set(
        action.payload.map(bet => `${bet.eventId}-${bet.id}`)
      );
      
      let bets = [...state.bets].map(bet => {
        const key = `${bet.eventId}-${bet.id}`;
        if (sourceMap.has(key)) {
          return { ...bet, addOnError: true };
        }
        return bet;
      });
      newState = {
        ...state,
        bets:bets
      };
      break;
    case UPDATE_CONFIG: 
       
      const mergedConfig = { ...state.config, ...action.payload };
      newState = {
        ...state,
        config: mergedConfig
      };
      break;
    case REMOVE_ON_ERROR:
      newState = removeBets(state,action.payload);
      break;
    case DISABLE:
      config.viewOnly = action.payload      
      newState = {
        ...state,
        config:config
      };
      break;
    case ACCEPT_ODDS_CHANGES:
      config.acceptOddsChange = action.payload
      newState = {
        ...state,
        config:config
      };
      break;
    case REMOVE_EVENT_BETS || REMOVE_EVENT:
      newState = removeEvent(state,action.payload);
      break;
    case REMOVE_EVENT:
      newState = removeEvent(state,action.payload);
      break;    
    case CLEAR_ALL:
      newState = {
        bets: [],
        totalOdds:[],
        __version:STORAGE_VERSION,
        config:state.config
      };
      break;
    case SET_TOTAL_ODDS:
      newState = setTotalOdds(state,action.payload);
      break;
      
    case RECALCULATE:
      newState = recalculate(state,action.payload);
      break;
    case CHANGE_CULTURE:
      config.culture = action.payload;
      newState = {
        ...state,
        config: config,
      };  
      break;  
    case ODDS_CHANGED:
      let existingIndex = state.bets.findIndex(bet => bet.id.toString() === action.payload.id.toString());
      let updatedOddsBets = [...state.bets]; 
      if(existingIndex>-1){
       
        updatedOddsBets[existingIndex].previouseOdds =  updatedOddsBets[existingIndex].odds; 
      }
      newState = {
        ...state,
        bets: updatedOddsBets,
      };  
      break;  
    case RESTORE_STATE:
      newState = action.payload;
      break;
    default:
      return state;
  }

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newState));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
  
  return newState;
};